<!--File: app.component.html-->
<!--Author: Joseph M Diaz-->
<!--Date: 4/20/2017-->
<!--Desc: Root template for the app. -->
<!--Other Contributors:-->

<cgp-app-bar></cgp-app-bar>

<div #cgpContentContainer class="cgp-content-container" [ngClass]="{'full-screen': isFullScreen}">

    <cgp-broadcast-message *ngIf="this.broadcastApplication as app" [application]="app.applicationId"
        [environment]="app.env">
    </cgp-broadcast-message>

    <mat-sidenav-container class="cgp-sidenav-container">
        <mat-sidenav mode="side" opened="{{sidenavVisible}}">
            <cgp-sidenav></cgp-sidenav>
        </mat-sidenav>

        <div *ngIf="!isLoggedIn" class="loading">
            <div class="spinner-container">
                <mat-spinner class="standard-spinner"></mat-spinner>
            </div>
        </div>

        <div [hidden]="!isLoggedIn" class="cgp-content">
            <cgp-breadcrumbs></cgp-breadcrumbs>
            <div class="content-container" [ngClass]="{'full-screen': isFullScreen}">
                <router-outlet></router-outlet>
            </div>
        </div>
    </mat-sidenav-container>
</div>

<cgp-footer *ngIf="IsShowFooter"></cgp-footer>